import fetch from 'cross-fetch';

import WpToastManager from 'Wpds/components/toast/WpToastManager';

export const externalAPICallFromRecommendation = ({ recommendation_id, button_key, additional_arguments }) => (
  dispatch,
  getState
) => {
  const state = getState();
  const { app } = state;
  const button_state_key = additional_arguments
    ? 'salesforce_record_modal:record_button'
    : `recommendation:${recommendation_id}:${button_key}`;

  dispatch({
    type: 'SET_BUTTON_STATE_LOADING',
    key: button_state_key,
  });

  return fetch('/api/v0/recommendations/external_api_call', {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ recommendation_id, button_key, app_id: app.id, arguments: additional_arguments }),
  })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: 'SET_BUTTON_STATE_LOADED',
        key: button_state_key,
      });

      if (json.error) {
        WpToastManager.danger(json.error);
      } else {
        if (json.data.modal) {
          dispatch({
            type: 'OPEN_SALESFORCE_RECORD_MODAL',
            ...json.data,
            button_key,
            recommendation_id,
          });
        } else {
          dispatch({
            type: 'CLOSE_SALESFORCE_RECORD_MODAL',
          });
        }

        if (json.data.toaster) {
          const { type, text } = json.data.toaster;

          if (type === 'warning') WpToastManager.warning(text);
          else WpToastManager.success(text);
        }

        if (json.data.recommendation_button) {
          dispatch({
            type: 'RECEIVE_RECOMMENDATION_BUTTON_CHANGE',
            ...json.data,
          });
        }
      }
    })
    .catch(() => WpToastManager.danger('Something went wrong on our end. Please try again.'));
};

export const addRecommendationClick = ({ recommendation_id, button_key, button_link }) => (dispatch, getState) => {
  const state = getState();
  const { app } = state;

  return fetch(`/api/v0/recommendations/${recommendation_id}/add_click`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ recommendation_id, app_id: app.id, button_key, button_link }),
  });
};

export const updateRecommendation = (userID, recId, type, options) => (dispatch, getState) => {
  const state = getState();
  const { app } = state;

  const url =
    type === 'completed_at' ? `/api/v0/recommendations/${recId}/complete` : `/api/v0/recommendations/${recId}/dismiss`;

  return fetch(url, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${options.token}`,
    },
    body: JSON.stringify({ app_id: app.id }),
  })
    .then(response => response.json())
    .then(json => {
      if (json.error) {
        WpToastManager.danger(json.error);
      } else {
        dispatch({
          type: 'RECEIVE_RECOMMENDATION_CHANGE',
          payload: {
            userID,
            recommendation: json.data,
          },
        });
      }
    })
    .catch(() => WpToastManager.danger('Something went wrong on our end. Please try again.'));
};

export const getRecommendations = (userID, options) => dispatch => {
  dispatch({
    type: 'REQUEST_USER_RECOMMENDATIONS',
  });

  return fetch(`/api/v0/recommendations?user_id=${userID}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${options.token}`,
    },
  })
    .then(response => response.json())
    .then(json => {
      if (json.error) {
        WpToastManager.danger(json.error);
      } else {
        dispatch({
          type: 'RECEIVE_USER_RECOMMENDATIONS',
          payload: {
            userID,
            recommendations: json.data,
          },
        });
      }
    })
    .catch(() => WpToastManager.danger('Something went wrong on our end. Please try again.'));
};

export const toggleRecommendation = (recID, userID, options) => dispatch =>
  fetch(`/api/v0/recommendations/${recID}/toggle_verification`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${options.token}`,
    },
  })
    .then(response => response.json())
    .then(json => {
      if (json.error) {
        WpToastManager.danger(json.error);
      } else {
        dispatch({
          type: 'RECEIVE_RECOMMENDATION_CHANGE',
          payload: {
            userID,
            recommendation: json.data,
          },
        });
      }
    })
    .catch(() => WpToastManager.danger('Something went wrong on our end. Please try again.'));
